import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import SponsorshipSection from "../../components/SponsorshipSection/SponsorshipSection";
import SponsorshipBenefits from "../../components/SponsorshipSection/SponsorshipBenefits";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";

const SponsorshipPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Sponsorship | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Partner with Cash Flow Summit 2026 as a sponsor. Get brand visibility, strategic exposure, and access to entrepreneurs, founders, and business leaders."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit sponsorship, event sponsor India, brand partnership, business summit sponsorship"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Sponsorship"} pagesub={"Sponsorship"} />
      <SponsorshipSection />
      <SponsorshipBenefits />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};

export default SponsorshipPage;
